// Tells when the opponent has posted a new host code for a match. The code a
// match has when it is first seen (the page loaded, the match arrived) is
// taken as known, so only codes posted after that count, each one once.

function keyOf(hostCode) {
	if(!hostCode || !hostCode.insert_player_id || !hostCode.code) {
		return null;
	}
	return `${hostCode.insert_player_id}:${hostCode.code}`;
}

export default function createHostCodeWatcher() {
	const knownCodes = new Map();
	return {
		// The match's host code if it is new and someone else posted it, else null.
		newOpponentCode(match) {
			if(!match || match.id === undefined || match.id === null) {
				return null;
			}
			const hostCode = match.host_code;
			const key = keyOf(hostCode);
			const seen = knownCodes.has(match.id);
			const known = knownCodes.get(match.id);
			knownCodes.set(match.id, key);
			if(!seen || !key || key === known) {
				return null;
			}
			const myId = typeof myUser === 'undefined' ? null : myUser?.id;
			if(String(hostCode.insert_player_id) === String(myId)) {
				return null;
			}
			return hostCode;
		},
	};
}
